import { FC } from "react"
import { useTranslation } from "react-i18next"
import { NumberPostfixConfig, NumberWithCorrectPostfix } from "../NumberWithCorrectPostfix"

type Props = {
    coin: number
}

export const CoinLabel: FC<Props> = ({ coin }) => {
    const { t } = useTranslation()

    const postfix: NumberPostfixConfig = {
        endsWithOne: t('coin.one'),
        endsBetweenTwoAndFour: t('coin.few'),
        other: t('coin.many'),
    }

    return <NumberWithCorrectPostfix value={coin} postfix={postfix} />
}